import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { SITE_URL } from "../../../actions/types";
import "../../../css/sb-admin-2.min.css";
import { useLocation } from "react-router-dom";

const Sidebar = ({ auth: { user, loading } }) => {
  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState(location.pathname);

  const handleRedirect = () => {
    window.location.href = "/admin-dashboard";
  };

  return (
    <ul
      className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
      id="accordionSidebar"
    >
      <a
        className="sidebar-brand d-flex align-items-center justify-content-center"
        onClick={handleRedirect}
      >
        <div className="sidebar-brand-logo-small d-none mx-3">
          <img
            src={`/img/rater-icon-logo.svg`}
            style={{ cursor: "pointer", width: "100%" }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
              e.target.src = "img/noImage.png"; // Fallback image if loading fails
            }}
          />
        </div>
        <div className="sidebar-brand-text mx-3">
          <img
            src={`/img/group-6.svg`}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
              e.target.src = "img/noImage.png"; // Fallback image if loading fails
            }}
            style={{ cursor: "pointer", width: "75%" }}
          />
        </div>
      </a>
      {/* Divider */}
      <hr className="sidebar-divider my-0" />
      {/* Nav Item - Dashboard */}
      <li
        className={
          window.location.pathname == "/admin-dashboard"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/admin-dashboard" className="nav-link">
          <i className="fas fa-fw fa-tachometer-alt" />
          <span>Dashboard</span>
        </Link>
      </li>
      <li
        className={
          window.location.pathname == "/user-management"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/user-management" className="nav-link">
          <i className="fas fa-user" />
          <span>Users</span>
        </Link>
      </li>
      <li
        className={
          window.location.pathname == "/delete-user-management"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/delete-user-management" className="nav-link">
          <i className="fas fa-user-slash" />
          <span>Users Marked for Deletion</span>
        </Link>
      </li>
      <li
        className={
          window.location.pathname == "/events" ? "active nav-item" : "nav-item"
        }
      >
        <Link to="/events" className="nav-link">
          <i className="far fa-calendar-alt" />
          <span>Events</span>
        </Link>
      </li>
      <li
        className={
          window.location.pathname == "/transactions"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/transactions" className="nav-link">
          <i className="fas fa-list" />
          <span>Transactions</span>
        </Link>
      </li>

      <li
        className={
          window.location.pathname == "/idmerit"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/idmerit" className="nav-link">
          <i className="fas fa-user-check"></i>
          <span>IDMerit</span>
        </Link>
      </li>

      <li
        className={
          window.location.pathname == "/idm-trust"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/idm-trust" className="nav-link">
          <i className="fas fa-check-circle"></i>
          <span>IDMtrust</span>
        </Link>
      </li>

      {/* <li
        className={
          window.location.pathname == "/community"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/community" className="nav-link">
          <i className="fas fa-check-circle"></i>
          <span>Community</span>
        </Link>
      </li> */}

      <li className="nav-item">
        <a
          className={
            window.location.pathname == "/add-admin" ||
            window.location.pathname == "/view-admin-list"
              ? "nav-link show"
              : "nav-link collapsed"
          }
          href="#"
          data-toggle="collapse"
          data-target="#collapsePages3"
          aria-expanded="true"
          aria-controls="collapsePages3"
          onClick={() => {
            var element = document.querySelector("#accordionSidebar");
            var ele = document.querySelector("#content-wrapper");
            ele.classList.remove("hide-body");
            element.classList.remove("toggled");
          }}
        >
          <i className="fas fa-user-circle" />
          <span>Communities</span>
        </a>

        <div
          id="collapsePages3"
          className={
            window.location.pathname == "/community" ||
            window.location.pathname == "/requested-community"
              ? "collapse show"
              : "collapse"
          }
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <Link to="/community" className="nav-link">
              <span
                className={`submenu${
                  activeMenu === "/community" ? " active" : ""
                }`}
                style={{ color: "black" }}
              >
                Community
              </span>
            </Link>
            <Link to="/requested-community" className="nav-link">
              <span
                className={`submenu${
                  activeMenu === "/requested-community" ? " active" : ""
                }`}
                style={{ color: "black" }}
              >
                Requested Community
              </span>
            </Link>
          </div>
        </div>
      </li>

      <li
        className={
          window.location.pathname == "/brightcheck"
            ? "active nav-item"
            : "nav-item"
        }
      >
        <Link to="/brightcheck" className="nav-link">
          <i className="fas fa-check-circle"></i>
          <span>Brightcheck</span>
        </Link>
      </li>

      <li className="nav-item">
        <a
          className={
            location.pathname === "/radar" ||
            location.pathname === "/radar-attendees"
              ? "nav-link show"
              : "nav-link collapsed"
          }
          href="#"
          data-toggle="collapse"
          data-target="#collapsePages"
          aria-expanded="true"
          aria-controls="collapsePages"
          onClick={() => {
            var element = document.querySelector("#accordionSidebar");
            var ele = document.querySelector("#content-wrapper");
            ele.classList.remove("hide-body");
            element.classList.remove("toggled");
          }}
        >
          <i className="fas fa-infinity" />
          <span>Radar</span>
        </a>
        <div
          id="collapsePages"
          className={
            location.pathname === "/radar" ||
            location.pathname === "/radar-attendees"
              ? "collapse show"
              : "collapse"
          }
          aria-labelledby="headingPages"
          data-parent="#accordionSidebar"
        >
          <div className="bg-white py-2 collapse-inner rounded">
            <Link
              to="/radar-attendees"
              className="nav-link"
              onClick={() => {
                setActiveMenu("/radar-attendees");
              }}
            >
              <span
                className={`submenu${
                  activeMenu === "/radar-attendees" ? " active" : ""
                }`}
                style={{ color: "black" }}
              >
                Radar Attendees
              </span>
            </Link>
            <Link
              to="/radar"
              className="nav-link"
              onClick={() => setActiveMenu("/radar")}
            >
              <span
                className={`submenu${activeMenu === "/radar" ? " active" : ""}`}
                style={{ color: "black" }}
              >
                Location Master
              </span>
            </Link>
          </div>
        </div>
      </li>

      {!loading && user && user.role && user.role == 2 ? (
        ""
      ) : (
        <li className="nav-item">
          <a
            className={
              window.location.pathname == "/add-admin" ||
              window.location.pathname == "/view-admin-list"
                ? "nav-link show"
                : "nav-link collapsed"
            }
            href="#"
            data-toggle="collapse"
            data-target="#collapsePages1"
            aria-expanded="true"
            aria-controls="collapsePages1"
            onClick={() => {
              var element = document.querySelector("#accordionSidebar");
              var ele = document.querySelector("#content-wrapper");
              ele.classList.remove("hide-body");
              element.classList.remove("toggled");
            }}
          >
            <i className="fas fa-user-circle" />
            <span>Administrators</span>
          </a>

          <div
            id="collapsePages1"
            className={
              window.location.pathname == "/add-admin" ||
              window.location.pathname == "/view-admin-list"
                ? "collapse show"
                : "collapse"
            }
            aria-labelledby="headingPages"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <Link to="/add-admin" className="nav-link">
                <span
                  className={`submenu${
                    activeMenu === "/add-admin" ? " active" : ""
                  }`}
                  style={{ color: "black" }}
                >
                  Add Admin
                </span>
              </Link>
              <Link to="/view-admin-list" className="nav-link">
                <span
                  className={`submenu${
                    activeMenu === "/view-admin-list" ? " active" : ""
                  }`}
                  style={{ color: "black" }}
                >
                  View Admins List
                </span>
              </Link>
            </div>
          </div>
        </li>
      )}

      {/* <li className="nav-item">
          <Link to="/reports" className="nav-link">
            <i className="fas fa-list" />
                <span>Reports</span>
          </Link>
        </li> */}
      <li className="nav-item">
        <Link to="/update-settings" className="nav-link">
          <i className="fas fa-fw fa-cog" />
          <span>Settings</span>
        </Link>
      </li>
    </ul>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Sidebar);
